import { allCountriesNewList } from './countryLists';
export const getAllCountries = () => allCountriesNewList;
export const allCountriesByCode = getAllCountries().reduce((allCountriesByCode, country) => {
  allCountriesByCode[country.code] = country;
  return allCountriesByCode;
}, {});
export function buildCountryDropdown() {
  const allCountriesHashmap = {};
  const allCountriesList = [];
  getAllCountries().forEach(country => {
    if (!allCountriesHashmap[country.phoneCode]) {
      allCountriesHashmap[country.phoneCode] = {
        names: [country.name],
        phoneCode: country.phoneCode
      };
    } else {
      if (country.code === 'us') {
        allCountriesHashmap[country.phoneCode].names.unshift(country.name);
      } else if (country.code !== 'pr') {
        allCountriesHashmap[country.phoneCode].names.push(country.name);
      }
    }
  });
  for (const keyNumber in allCountriesHashmap) {
    if (Object.prototype.hasOwnProperty.call(allCountriesHashmap, keyNumber)) {
      const number = Object.assign({}, allCountriesHashmap[keyNumber]);
      number.names = `+${keyNumber} ${number.names.join(' and ')}`;
      allCountriesList.push(number);
    }
  }
  return allCountriesList;
}
export const uniqCountryCodes = buildCountryDropdown().map(country => {
  return {
    phoneCode: parseInt(country.phoneCode),
    label: country.names
  };
});